<template>
<div>
<appointment-detail
  :initial-appointment='appointment'
  :appointment-id='appointmentId'
  :is-compact='$vuetify.breakpoint.xs' ></appointment-detail>
</div>
</template>
<script type="text/javascript">
import AppointmentDetail from '@/components/appointment/AppointmentDetail'

export default {
  name: 'AppointmentPage',
  components: {AppointmentDetail},
  computed: {
    appointmentId () {
      return this.$route.params.id
    },
    appointment () {
      let vm = this
      return this.$store.getters.appointments.find((appt) => {
        return (appt.id.toString() === vm.appointmentId)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Appointment.vue?3e5f62c4